var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.s.container,on:{"click":_vm.onClick}},[_c('span',{class:_vm.s.text},[_vm._v(_vm._s(_vm.text))]),_c('Icon',{class:_vm.s.gray,attrs:{"icon":_vm.isLink ? 'open_in_new' : 'copy',"small":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }